"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralRoutes = void 0;
var TransactionsHome_1 = require("../pages/secure/transactions/TransactionsHome");
/*
* Permission is required, otherwise the route will not be rendered.
* Set showInMenu to true if you want to add this item to the submenu.
*/
exports.GeneralRoutes = [
    {
        component: TransactionsHome_1.TransactionsHome,
        path: '/transactions',
        title: 'Transactions',
        exact: true,
        showInMenu: false,
    },
    {
        component: TransactionsHome_1.TransactionsHome,
        path: '/transaction/1',
        title: 'Transactions',
        exact: true,
        showInMenu: false,
    }
];
//# sourceMappingURL=GeneralRoutes.js.map